export const CLASS_PERIODS = [1, 2, 3, 4, 5, 6, 7, 8];

/** `period` filter value for students the teacher hasn't put in a period. */
export const UNASSIGNED_CLASS_PERIOD = 'none';
